import { Injectable } from '@angular/core';
import { OpenIdConfiguration, StsConfigLoader } from 'angular-auth-oidc-client';
import { Observable, ReplaySubject } from 'rxjs';

// angular-auth-oidc-client 12+ takes its configuration from a StsConfigLoader instead of the old
// OidcConfigService.withConfig(). The OIDC configuration here is only known after
// AuthenticationService.configureOidc() has asked the backend for the authority, so this loader is
// fed at run time; the library subscribes to loadConfigs() only when an OIDC call is made, which never
// happens while OIDC mode is disabled (see StartupService.init).
@Injectable({ providedIn: 'root' })
export class PcsOidcConfigLoader extends StsConfigLoader {
    private readonly configs$ = new ReplaySubject<OpenIdConfiguration[]>(1);

    setConfig(config: OpenIdConfiguration): void {
        this.configs$.next([config]);
        this.configs$.complete();
    }

    loadConfigs(): Observable<OpenIdConfiguration[]> {
        return this.configs$.asObservable();
    }
}
